import React from "react";
import { SourceCopy } from "types";
import { SourceName } from "../../../Common/SourceIcon";
import { RowData } from "./types";

export const sourceCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    return data.isOrganizer ? SourceCopy[data.item.source] : null;
};

export const SourceCellRenderer = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    return data.isOrganizer ? (
        <span className="flex items-center" data-testid="roster-guests-list-source-cell">
            {SourceCopy[data.item.source] ?? <SourceName source={data.item.source} />}
        </span>
    ) : null;
};
